import { ContextDispatcher } from "./Variables";
import { ContextType } from "../../Wrap/Constants/Enums/ContextType";

export interface IContextAction {
    hierarchyId: string;
    contextType: ContextType;
}

export class ContextActions {
    public static setContext(hierarchyId: string, contextType: ContextType) {
        ContextDispatcher.dispatch({ contextType: contextType, hierarchyId: hierarchyId });
    }
}
